import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, WHATSAPP_DISPLAY, waLink, DEFAULT_WA_MESSAGE } from "../config/site";
import { WhatsAppIcon } from "./Cta";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-nuit-900/85 backdrop-blur-xl">
        <div className="container-nv flex h-16 items-center justify-between sm:h-[72px]">
          <Link to="/" aria-label="Noveocard — Accueil" data-testid="nav-logo" className="shrink-0">
            <img src="/assets/logo-white.png" alt="Noveocard" className="h-5 w-auto sm:h-6" width="169" height="24" />
          </Link>

          <nav className="hidden items-center gap-7 xl:flex" aria-label="Navigation principale">
            {NAV_LINKS.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                className="link-line text-[13px] font-medium text-white/75 transition-colors hover:text-white"
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-cta-whatsapp"
              className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-electric px-5 py-2.5 font-display text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-electric-600 sm:inline-flex"
            >
              <WhatsAppIcon className="h-4 w-4" />
              Commander sur WhatsApp
            </a>
            <button
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white xl:hidden"
              onClick={() => setOpen(true)}
              aria-label="Ouvrir le menu"
              data-testid="nav-menu-open"
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[60] flex flex-col bg-nuit-950"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            role="dialog"
            aria-modal="true"
            aria-label="Menu"
          >
            <div className="container-nv flex h-16 items-center justify-between">
              <img src="/assets/logo-white.png" alt="Noveocard" className="h-6 w-auto" width="150" height="21" />
              <button
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white"
                onClick={() => setOpen(false)}
                aria-label="Fermer le menu"
                data-testid="nav-menu-close"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <nav className="container-nv mt-6 flex flex-1 flex-col gap-1" aria-label="Navigation mobile">
              {NAV_LINKS.map(({ to, label }, i) => (
                <motion.div
                  key={to}
                  initial={{ opacity: 0, x: -24 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.06 * i, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                >
                  <NavLink
                    to={to}
                    end={to === "/"}
                    onClick={() => setOpen(false)}
                    className="block border-b border-white/8 py-4 font-display text-3xl font-semibold text-white/85 transition-colors hover:text-electric-300"
                  >
                    {label}
                  </NavLink>
                </motion.div>
              ))}
            </nav>
            <div className="container-nv pb-10">
              <a
                href={waLink(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-cta-whatsapp"
                className="flex items-center justify-center gap-3 rounded-full bg-electric px-6 py-4 font-display text-lg font-semibold text-white"
              >
                <WhatsAppIcon className="h-5 w-5" />
                Commander ma carte sur WhatsApp
              </a>
              <p className="mt-3 text-center text-sm text-white/60">{WHATSAPP_DISPLAY} · Réponse sous 30 minutes</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
